import { render, staticRenderFns } from "./EnterTipsAudio.vue?vue&type=template&id=29ca2760&scoped=true&"
import script from "./EnterTipsAudio.vue?vue&type=script&lang=js&"
export * from "./EnterTipsAudio.vue?vue&type=script&lang=js&"
import style0 from "./EnterTipsAudio.vue?vue&type=style&index=0&id=29ca2760&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ca2760",
  null
  
)

export default component.exports